var constants = require('../constants.js');

function findParameter(param) {
  var result = null;
  var tmp = [];
  var i;
  var items = window.location.search.substr(1).split('&');
  for (i = 0; i < items.length; i++) {
    tmp = items[i].split('=');
    if (tmp[0].toLowerCase() === param.toLowerCase()) {
      result = decodeURIComponent(tmp[1]);
    }
  }
  return result;
}

function pushState(url) {
  window.history.pushState(null, null, url);
}

function getQueryParameters() {
  return window.location.search;
}

function addParamToURL(param, value) {
  // Original url without the query string but including hashes
  var items = window.location.search.substr(1).split('&');
  var hash = window.location.hash;
  var result = window.location.protocol + '//' + window.location.host + window.location.pathname + '?';

  items = items.filter(function filtering(item) { return item !== ''; });

  items.push(param + '=' + value);

  return result + items.join('&') + hash;
}

function replaceParamOnURL(param, value) {
  // Original url without the query string but including hashes
  var items = window.location.search.substr(1).split('&');
  var hash = window.location.hash;
  var params = [];

  var result = window.location.protocol + '//' + window.location.host + window.location.pathname;

  if (items.length > 0) {
    result += window.location.search[0];
  }

  items.forEach(function itemValues(item) {
    var tmp = item.split('=');
    var newItem = item;

    if (tmp[0].toLowerCase() === param.toLowerCase()) {
      newItem = tmp[0] + '=' + value;
    }

    params.push(newItem);
  });

  return result + params.join('&') + hash;
}

function updateZipcodeQuery(zipcode) {
  var queryZipcode = findParameter(constants.global.ZIPCODE_PARAM);
  var url = '';

  if (queryZipcode) {
    url = replaceParamOnURL(constants.global.ZIPCODE_PARAM, zipcode);
  } else {
    url = addParamToURL(constants.global.ZIPCODE_PARAM, zipcode);
  }

  pushState(url);
}

module.exports = {
  url: {
    parameters: getQueryParameters,
    updateZipcodeQuery: updateZipcodeQuery,
    findParameter: findParameter,
  },
};
